/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import cx from 'classnames';
import { Button } from '@/components/Button';
import styles from './styles.module.scss';

export type ChipTagProps = {
  selectedChipVariant?: 'checkmarkLeft' | 'checkmarkRight' | 'mobileDrawer';
  chipVariant?: 'default' | 'slim';
  isChecked?: boolean;
  ariaLabel?: string;
  label?: string;
  handleFilter: () => void;
};

export const ChipTag = (props: ChipTagProps) => {
  const {
    selectedChipVariant,
    chipVariant = 'default',
    isChecked,
    ariaLabel,
    label,
    handleFilter,
  } = props;
  return (
    <Button
      customClass={cx({
        [styles.filterChip]: chipVariant === 'default' && selectedChipVariant !== 'mobileDrawer',
        [styles.slimFilterChip]: chipVariant === 'slim',
        [styles.selectedFilterChipRight]: isChecked && selectedChipVariant === 'checkmarkRight',
        [styles.selectedFilterChipLeft]: isChecked && selectedChipVariant === 'checkmarkLeft',
        [styles.mobileDrawerFilterChip]: isChecked && selectedChipVariant === 'mobileDrawer',
      })}
      ariaLabel={ariaLabel}
      variant="ghost"
      onClick={() => handleFilter()}
    >
      <span className={styles.filterLabel}>{label}</span>
    </Button>
  );
};
